import styles from '../../../Fireboard/components/Header/header.module.scss';
import cn from 'classnames';
import CubbyFilter from './CubbyFilters';
import classes from './toggle.module.scss';
import { ReactComponent as Hamburger } from '@assets/images/Fireboard/hamburgerFireboard.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const CubbyHeader = props => {
  const {
    sortByName,
    ascendingCheck,
    showClosedChecks,
    onToggleSwitch,
    onClickHamburger,
  } = props;

  return (
    <div
      className={cn(
        styles.hamHeader,
        classes.headerMargin,
        'col-12 d-flex align-items-center justify-content-between'
      )}
    >
      <div className="d-flex align-items-center col-4 px-0">
        <span
          className={cn(
            'd-flex justify-content-center align-items-center position-relative',
            styles.BackIcon
          )}
          onClick={() => onClickHamburger(true)}
        >
          <Hamburger fill='var(--header-icon-color)' />
        </span>
        <div className={cn('fs-16 fw-500 pl-3',styles.headerLabel)}>{FLABEL().HEADER_CUBBY_MANAGER}</div>
      </div>

      <div className="d-flex justify-content-end align-items-center col-8 px-0">
        <CubbyFilter
          onToggleSwitch={onToggleSwitch}
          sortByName={sortByName}
          ascendingCheck={ascendingCheck}
          showClosedChecks={showClosedChecks}
        />
      </div>
    </div>
  );
};

export default CubbyHeader;
